import { LayoutComponent } from './shared/components/layout/layout.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './modules/register/pages/register/register.component';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  }, {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  //  {
  //   path: 'register',
  //   component: RegisterComponent,
  //   data: {
  //     title: "register",
  //     breadcrumb: 'register'
  //   }
  // },
   {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/homepage/homepage.module').then(m => m.HomepageModule),
        data: {
          title: "หน้าแรก",
          breadcrumb: 'หน้าแรก'
        }
      }
    ]
  }, {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
